<landing-header></landing-header>
<section class="landing-content">
  <router-outlet></router-outlet>
</section>
<landing-footer></landing-footer>
